import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { MDSLeftNavBar, MDSMarqContentWhiteLogo, MDSNavItem } from '@marqvision/mds/core';
import { ToastContainer } from '@marqvision/shared';
import { LayoutWrapperContext } from './LayoutWrapper';
import { RouteParams } from './RouteParams';
import Header, { headerHeight } from './Header/Header';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      height: `calc(100vh - ${headerHeight})`,
      overflow: 'overlay',
      overflowX: 'hidden',
      marginTop: headerHeight,
      marginLeft: '16px',
    },
    descriptionBox: {
      color: '#5b6985',
      lineHeight: '1.43',
      margin: '10px 24px 0',
      padding: '8px 20px',
      borderRadius: 6,
      border: 'solid 1px #e6edff',
      backgroundColor: '#f7f9fc',
      fontSize: 13,
    },
    content: {
      inset: '0px',
      position: 'relative',
      overflow: 'overlay',
      flexGrow: 1,
      backgroundColor: 'white',
      borderRadius: '24px 24px 0 0',
    },
    nonStickyWrapper: {
      position: 'relative',
      backgroundColor: '#fff',
      zIndex: 1100,
    },
    stickyHeaderShadow: {
      position: 'fixed',
      width: '100%',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.04), 0px 1px 8px rgba(0, 0, 0, 0.12)',
      height: '107px',
      top: 0,
      zIndex: 1,
    },
    nonStickyHeaderShadow: {
      height: headerHeight,
    },
  })
);

interface IProps {
}

const Layout = (props: PropsWithChildren<IProps>): JSX.Element => {
  const classes = useStyles();

  const {children} = props;

  const [
    {title, description, tabs, stickyHeader, renderActionButton, renderMenuButton, renderControls},
  ] = useContext(LayoutWrapperContext);

  const [openNav, setOpenNav] = useState(true);
  const [isOffsetTop, setIsOffsetTop] = useState(true);

  const handleScroll = useCallback((e: any) => {
    setIsOffsetTop(e.target.scrollTop === 0);
  }, []);

  return (
    <div className={classes.root}>
      <Header
        openNav={openNav}
        title={title}
        renderActionButton={renderActionButton}
        renderMenuButton={renderMenuButton}
      />
      <Box display="flex" width="100%">
        <MDSLeftNavBar logo={<MDSMarqContentWhiteLogo />} HomeLink={'/'} style={{zIndex: 1110}} onOpenNav={setOpenNav}>
          {RouteParams.map((menu) => (
            <MDSNavItem
              key={menu.to}
              label={menu.text}
              link={menu.to}
              icon={<menu.icon/>}
            />
          ))}
        </MDSLeftNavBar>
        <main className={clsx(classes.content)} onScroll={handleScroll}>
          <div className={classes.nonStickyWrapper}>
            {tabs}
            {description && (
              <Box paddingTop="10px" marginTop="-10px">
                <div className={classes.descriptionBox}>{description}</div>
              </Box>
            )}
            {renderControls && <Box padding="10px 24px 0">{renderControls()}</Box>}
          </div>
          <>
            {(stickyHeader || !isOffsetTop) && (
              <div
                className={clsx(classes.stickyHeaderShadow, {
                  [classes.nonStickyHeaderShadow]: !stickyHeader && !isOffsetTop,
                })}
              />
            )}
            {stickyHeader}
          </>
          {children}
          <ToastContainer />
        </main>
      </Box>
    </div>
  );
};

export default Layout;
